var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.wrapper},[_c('div',{class:_vm.$style.spinner},[_c('n8n-spinner')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }